import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useCart } from "../../../hooks/useCart";
import CartDropdown from "./CartDropdown";

interface NavbarProps {
  scrolled: boolean;
}

export default function Navbar({ scrolled }: NavbarProps) {
  const { cartCount } = useCart();
  const [cartOpen, setCartOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (id: string) => {
    setCartOpen(false);
    setMenuOpen(false);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleSectionNav = (id: string) => {
    setCartOpen(false);
    setMenuOpen(false);
    if (location.pathname === "/") {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate(`/#${id}`);
    }
  };

  const handleContinueShopping = () => {
    setCartOpen(false);
    const element = document.getElementById("products");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? "bg-white shadow-md" : "bg-white shadow-md"}`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link
            to="/"
            className="flex items-center gap-2 cursor-pointer hover:scale-105 transition-transform duration-300"
          >
            <img
              src="https://static.readdy.ai/image/000f6613bbd5bf7f02c140851804a982/edb968f21dc844722d3645b2f59fd129.png"
              alt="Curewell Logo"
              className="h-7 md:h-10 w-auto object-contain"
            />
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <button
              onClick={() => {
                if (location.pathname === "/") {
                  window.scrollTo({ top: 0, behavior: "smooth" });
                } else {
                  navigate("/");
                }
              }}
              className="text-sm font-medium text-gray-700 hover:text-white hover:bg-[#144E5D] px-3 py-1.5 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Home
            </button>
            <button
              onClick={() => handleSectionNav("products")}
              className="text-sm font-medium text-gray-700 hover:text-white hover:bg-[#144E5D] px-3 py-1.5 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Products
            </button>
            <button
              onClick={() => handleSectionNav("about")}
              className="text-sm font-medium text-gray-700 hover:text-white hover:bg-[#144E5D] px-3 py-1.5 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              About
            </button>
            {/*
            <a
              onClick={() => scrollToSection("testimonials")}
              className="text-sm font-medium text-gray-700 hover:text-[#144E5D] transition-all duration-300 cursor-pointer whitespace-nowrap hover:scale-110"
            >
              Testimonials
            </a>
            */}
            <Link
              to="/contact"
              className="text-sm font-medium text-gray-700 hover:text-white hover:bg-[#144E5D] px-3 py-1.5 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Contact
            </Link>
          </div>

          <div className="flex items-center gap-4">
            {/*
            <div className="relative">
              <button
                onClick={() => setCartOpen((prev) => !prev)}
                className="relative w-10 h-10 flex items-center justify-center text-gray-700 hover:text-[#144E5D] transition-all duration-300 cursor-pointer hover:scale-110"
              >
                <i className="ri-shopping-cart-2-line text-xl"></i>
                {cartCount > 0 && (
                  <span className="absolute -top-1 -right-1 w-5 h-5 bg-[#144E5D] text-white text-xs font-bold rounded-full flex items-center justify-center">
                    {cartCount}
                  </span>
                )}
              </button>

              {cartOpen && (
                <CartDropdown
                  onClose={() => setCartOpen(false)}
                  onContinueShopping={handleContinueShopping}
                />
              )}
            </div>
            */}

            <button
              onClick={() => setMenuOpen((prev) => !prev)}
              className="md:hidden w-10 h-10 flex items-center justify-center text-gray-700 hover:text-[#144E5D] transition-all duration-300 cursor-pointer hover:scale-110"
            >
              <i
                className={`text-2xl transition-all duration-300 ${menuOpen ? "ri-close-line" : "ri-menu-line"}`}
              ></i>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Dropdown Menu */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-300 ease-in-out ${
          menuOpen ? "max-h-80 opacity-100" : "max-h-0 opacity-0"
        } bg-white border-t border-gray-100`}
      >
        <div className="flex flex-col px-6 py-4 gap-1">
          <button
            onClick={() => {
              setMenuOpen(false);
              if (location.pathname === "/") {
                window.scrollTo({ top: 0, behavior: "smooth" });
              } else {
                navigate("/");
              }
            }}
            className="w-full text-left px-3 py-3 text-sm font-medium text-gray-700 hover:text-[#144E5D] hover:bg-[#f0f8fa] rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap block"
          >
            Home
          </button>
          <button
            onClick={() => handleSectionNav("products")}
            className="w-full text-left px-3 py-3 text-sm font-medium text-gray-700 hover:text-[#144E5D] hover:bg-[#f0f8fa] rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap block"
          >
            Products
          </button>
          <button
            onClick={() => handleSectionNav("about")}
            className="w-full text-left px-3 py-3 text-sm font-medium text-gray-700 hover:text-[#144E5D] hover:bg-[#f0f8fa] rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap block"
          >
            About
          </button>
          <Link
            to="/contact"
            onClick={() => setMenuOpen(false)}
            className="w-full text-left px-3 py-3 text-sm font-medium text-gray-700 hover:text-[#144E5D] hover:bg-[#f0f8fa] rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap block"
          >
            Contact
          </Link>
          <div className="pt-2 border-t border-gray-100 mt-1">
            <button
              onClick={() => scrollToSection("products")}
              className="w-full px-4 py-2.5 bg-[#144E5D] hover:bg-[#B8D8DE] text-white hover:text-[#144E5D] text-sm font-medium rounded-lg transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              View Products
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
